import React from 'react'
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./PopularUseCases.css";
import Usecase from "images/robots/goopter-hardware-restaurant-use-case.jpg";
import HotelUsecase from "images/robots/goopter-hardware-hotel-use-case.jpg";

export default function PopularUseCases() {
  const data = {
    features: [
      {
        img: Usecase,
        title: "hardware_pop_use_case1_title",
        text1: "hardware_pop_use_case1_text1",
        text2: "hardware_pop_use_case1_text2",
        link: "/use-case-dining-automation",
      },
      {
        img: HotelUsecase,
        title: "hardware_pop_use_case2_title",
        text1: "hardware_pop_use_case2_text1",
        text2: "hardware_pop_use_case2_text2",
        link: "/use-case-hotel-service-automation",
      },
    ],
  };
    return (
        <section className="popular-use-cases">
        <div className="container">
          <div className="title">
            <h2>
            <FormattedMessage id="popular_use_cases" />
            </h2>
          </div>
          {data.features.length > 0
            ? data.features.map((item, index) => (
                <div
                  className={index % 2 == 0 ? "row" : "row flex-row-reverse"}
                >
                  <div className="col-lg-6">
                    <div className="text-box">
                      <div className="table-cell">
                        <h3 className="accent">
                          <FormattedMessage id={item.title} />
                        </h3>
                        <p>
                          <FormattedMessage id={item.text1} />
                        </p>
                        <p>
                          <FormattedMessage id={item.text2} />
                        </p>
                        <Link to={item.link} className="text-btn">
                        <FormattedMessage id="learn_more" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    {item.img ? (
                      <div className="img-box">
                        <div className="table-cell">
                          <img src={item.img} alt="goopter flashbot" />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              ))
            : null}
        </div>
      </section>
    )
}
